<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="thisYear"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-filters
        v-model="source_filter"
        :filters="source_filter_options"
        name="filterStatus"
        @change="onChangeFilter"
      />
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <app-grid col="3" items="3" v-else>
      <template #item-1>
        <v-client-table
          :data="table_citizenship.items"
          :columns="table_citizenship.columns"
          :options="table_citizenship.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #name="{ row }">
            <div class="table-default__left table-default__controls">
              <span :class="`fflag ff-md fflag-${row[1].country_code || 'empty'}`"></span>
              {{ row[0] }}
            </div>
          </template>
          <template #count="{ row }">{{ row[1].count }}</template>
        </v-client-table>
      </template>
      <template #item-2>
        <v-client-table
          :data="table_age.items"
          :columns="table_age.columns"
          :options="table_age.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name><div class="table-default__left">Age</div></template>
          <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1] }}</template>
        </v-client-table>
      </template>
      <template #item-3>
        <v-client-table
          :data="table_gender.items"
          :columns="table_gender.columns"
          :options="table_gender.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1] }}</template>
        </v-client-table>
      </template>
    </app-grid>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { getSafariAnalyticsPersonalInfo, getClimbingAnalyticsPersonalInfo, getClientsAnalyticsPersonalInfo } from '@/http'
export default {
  name: 'CRMAnalyticsURLs',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      table_preloader: false,
      custom_shortcuts: [
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      source_filter: 'general',
      source_filter_options: [
        { value: 'general', label: 'General' },
        { value: 'climbing', label: 'Climbing' },
        { value: 'safari', label: 'Safari' },
      ],
      request: {
        general: getClientsAnalyticsPersonalInfo,
        climbing: getClimbingAnalyticsPersonalInfo,
        safari: getSafariAnalyticsPersonalInfo,
      },
      table_citizenship: {
        items: [],
        columns: ['name', 'count'],
        options: {
          headings: {
            'name': 'Name',
            'count': 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_age: {
        items: [],
        columns: ['name', 'count'],
        options: {
          headings: {
            'name': 'Name',
            'count': 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_gender: {
        items: [],
        columns: ['name', 'count'],
        options: {
          headings: {
            'name': 'Name',
            'count': 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchItems()
      })
    }, 0)
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      this.request[this.source_filter](this.filter_dates.start, this.filter_dates.end)
        .then(response => {
          this.table_citizenship.items = Object.entries(response.data.citizenship.data)
          this.table_age.items = Object.entries(response.data.age.data)
          this.table_gender.items = Object.entries(response.data.gender.data)
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onChangeFilter() {
      this.fetchItems()
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
  }
}
</script>
